var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "customWidth h-full" },
    [
      _c(
        "FadeOverlay",
        { staticClass: "h-full", attrs: { shown: _vm.cardDisabled } },
        [
          _c(
            "div",
            {
              staticClass:
                "font-strict flex flex-col relative h-full px-4 py-7 border-2 border-transparent",
              class: _vm.cardStyles,
            },
            [
              _c("PriceCardViewTitle", {
                attrs: {
                  label: _vm.cardLabel,
                  slogan: _vm.slogan,
                  title: _vm.title,
                  status: _vm.status,
                  disabled: _vm.cardDisabled,
                  cancelAtPeriodEnd: _vm.cancelAtPeriodEnd,
                },
              }),
              _c(
                "div",
                { staticClass: "flex flex-col justify-between flex-1" },
                [
                  _vm._t("planConditions", function () {
                    return [
                      _c(
                        "PriceCardViewPricing",
                        {
                          attrs: {
                            managersCount: _vm.managersCount,
                            price: _vm.price,
                            currentSubscription: _vm.currentSubscription,
                            generalSubscriptionPlans:
                              _vm.generalSubscriptionPlans,
                            checkIfPlanIsPremium: _vm.checkIfPlanIsPremium,
                            basic: "",
                          },
                        },
                        [
                          _vm.isCurrentSubscription
                            ? _c(
                                "SubscriptionPeriod",
                                {
                                  attrs: {
                                    canceled: _vm.canceledPeriod,
                                    periodEnd: _vm.periodEnd,
                                  },
                                },
                                [
                                  _vm.isPastDueStatus
                                    ? _c("p", { staticClass: "text-red-500" }, [
                                        _vm._v(" Payment attempt failed "),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  }),
                  _vm.cardDisabled
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "text-xs bg-gray-400 uppercase text-center font-bold mb-3 p-1 text-white z-100",
                        },
                        [_vm._v(" " + _vm._s(_vm.disabledCardMessage) + " ")]
                      )
                    : _vm._e(),
                  _vm.checkIfPlanIsPremium
                    ? _c(
                        "div",
                        [_vm.shouldNotShowSlot ? _c("p") : _vm._t("default")],
                        2
                      )
                    : _c("div", [_vm._t("default")], 2),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }